// Treat unavailable numeric inputs as missing, not as zero.
export const toReportNumber = (value) => {
  if (value == null || typeof value === 'boolean' || (typeof value === 'string' && !value.trim())) return null;
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

// Guard display boundaries, including invalid values already formatted with units.
export const reportDisplay = (value) => {
  if (value == null || value === '') return '-';
  if (typeof value === 'number') return Number.isFinite(value) ? value : '-';
  if (typeof value === 'string' && /^\s*[+-]?(?:NaN|Infinity|∞)(?:\s|%|$)/i.test(value)) return '-';
  return value;
};

export const formatReportNumber = (value, digits, suffix = '') => {
  const number = toReportNumber(value);
  if (number == null) return '-';
  return `${digits == null ? number.toLocaleString() : number.toFixed(digits)}${suffix}`;
};
